var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.41667C11.5323 5.41157 13.0349 5.83899 14.3351 6.64977C15.6353 7.46056 16.6804 8.6218 17.35 10C15.975 12.8083 13.1667 14.5833 10 14.5833C6.83337 14.5833 4.02504 12.8083 2.65004 10C3.31972 8.6218 4.36473 7.46056 5.66494 6.64977C6.96515 5.83899 8.46776 5.41157 10 5.41667ZM10 3.75C5.83337 3.75 2.27504 6.34167 0.833374 10C2.27504 13.6583 5.83337 16.25 10 16.25C14.1667 16.25 17.725 13.6583 19.1667 10C17.725 6.34167 14.1667 3.75 10 3.75ZM10 7.91667C10.5526 7.91667 11.0825 8.13616 11.4732 8.52686C11.8639 8.91756 12.0834 9.44747 12.0834 10C12.0834 10.5525 11.8639 11.0824 11.4732 11.4731C11.0825 11.8638 10.5526 12.0833 10 12.0833C9.44751 12.0833 8.9176 11.8638 8.5269 11.4731C8.1362 11.0824 7.91671 10.5525 7.91671 10C7.91671 9.44747 8.1362 8.91756 8.5269 8.52686C8.9176 8.13616 9.44751 7.91667 10 7.91667ZM10 6.25C7.93337 6.25 6.25004 7.93333 6.25004 10C6.25004 12.0667 7.93337 13.75 10 13.75C12.0667 13.75 13.75 12.0667 13.75 10C13.75 7.93333 12.0667 6.25 10 6.25Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9b55c64b3b00aad1f7ccb9277920742f.svg";
export { ForwardRef as ReactComponent };